export default {"src":"/_next/static/media/globant.804224c0.svg","height":174,"width":598,"blurWidth":0,"blurHeight":0};